// extracted by mini-css-extract-plugin
module.exports = {"label":"Pee_label__2g7zn","datepicker":"Pee_datepicker__2Y-ff","regime":"Pee_regime__31Rcu"};